export interface ExplicitOccAccountContext {
  soldTo: string;
  salesOrg: string;
  endCustomer?: string;
}

export interface OccRequestOptions {
  accountContext?: "current" | "omit" | ExplicitOccAccountContext;
}

export type OccTransportOptions = OccRequestOptions;

export interface OccTransport {
  request(url: string, init?: RequestInit, options?: OccRequestOptions): Promise<Response>;
  post(url: string, init?: Omit<RequestInit, "method">): Promise<Response>;
  put(url: string, init?: Omit<RequestInit, "method">, options?: OccRequestOptions): Promise<Response>;
  baseSiteUrl(path: string): string;
  url(path: string): string;
  userPath(): string;
}

let transport: OccTransport | undefined;

/**
 * Registers the application-owned OCC transport behind a lower-layer port.
 *
 * This keeps domains independent of app infrastructure while preserving the
 * authenticated token, account-context, and session-expiry behavior owned by
 * the app transport.
 */
export function configureOccTransport(nextTransport: OccTransport): void {
  transport = nextTransport;
}

export function getOccTransport(): OccTransport {
  if (!transport) {
    throw new Error("OCC transport has not been configured");
  }
  return transport;
}
